<!--银行付款导入模板组件-->
<template>
  <el-popover placement="bottom-start" trigger="hover">
    <div class="mb10">
      <!--下载模板-->
      <el-button
        size="small"
        icon="el-icon-download"
        type="primary"
        @click="downloadTemplate"
      >{{ $t('receivablePayable.DownloadTheTemplate') }}
      </el-button>
    </div>
    <div>
      <!--导入文件-->
      <uploadExcel
        :on-success="onImportFile"
        :but-name="$t('receivablePayable.ImportFile')"
      />
    </div>
    <el-button
      slot="reference"
      type="primary"
      size="mini"
    >{{ $t('basicData.BankAccountImport') }}
    </el-button>
  </el-popover>
</template>

<script>
import { saveAs } from 'file-saver';
import { apiDeliveryPayableAccountImport, apiCabinCollectionPayableAccountImport } from '@/api/newFinance';
import { goFileUploadManagement } from '@/utils/goExportList';

const ExcelJS = require('exceljs');

export default {
  name: 'BankPaymentImportTemplate',

  components: {
    uploadExcel: () => import('@/components/UploadExcel/index.vue')
  },

  props: {
    // 导入文件成功回调
    bankList: {
      type: Array,
      default: () => []
    },
    // 导入类型，用于区分导入模板的类型1.AJD 2.DSP 3.安骏小屋
    type: {
      type: [Number, String],
      required: true,
      default: ''
    }
  },

  data() {
    return {
      dictCodeTypeList: [
        {
          value: 'CPF',
          label: 'CPF'
        },
        {
          value: 'CNPJ',
          label: 'CNPJ'
        },
        {
          value: 'MOBILE PHONE',
          label: 'MOBILE PHONE'
        },
        {
          value: 'EMAIL',
          label: 'EMAIL'
        },
        {
          value: 'EVP',
          label: 'EVP'
        }
      ]
    };
  },

  methods: {
    // 下载模板
    downloadTemplate() {
      const that = this;
      let row;
      async function ddd() {
        const wb = new ExcelJS.Workbook();
        const Sheet1 = wb.addWorksheet('Sheet1');
        const Sheet2 = wb.addWorksheet('Sheet2');
        const Sheet3 = wb.addWorksheet('Sheet3');
        const Sheet4 = wb.addWorksheet('Sheet4');
        const Sheet5 = wb.addWorksheet('Sheet5');
        const columns = [
          {
            header: '*' + that.$t('basicData.PaymentMethod'), // 付款方式,
            key: 'paymentMethod',
            width: 40
          },
          {
            header: '*' + 'PIX' + that.$t('receivablePayable.accountType'), // '账户类型',
            key: 'dictCodeType',
            width: 40
          },
          {
            header: '*' + 'PIX' + that.$t('customerManagements.account'), // '账户',
            key: 'dictCode',
            width: 40
          },
          {
            header: '*' + that.$t('basicData.ReceivingName'), // '收款名称',
            key: 'payeeName',
            width: 40
          },
          {
            header: '*' + that.$t('orderCenterCont.CertificateType'), // 证件类型',
            key: 'documentType',
            width: 40
          },
          {
            header: '*' + that.$t('basicData.CertificateNumber'), // 证件号码',
            key: 'documentNumber',
            width: 40
          },
          {
            header: '*' + that.$t('basicData.BankNumber'), // '银行编号,
            key: 'bankCode',
            width: 40
          },
          {
            header: '*' + that.$t('basicData.BranchNumber'), // 分行号',
            key: 'branch',
            width: 40
          },
          {
            header: '*' + that.$t('basicData.ReceivingAccountNumber'), // 收款账户,
            key: 'bankNumber',
            width: 40
          }
        ];

        if ([2, 3].includes(that.type)) {
          row = {
            header: '*' + that.$t('basicData.supplierNumber'), // 供应商编号,
            key: 'code',
            width: 40
          };
        } else {
          row = {
            header: '*' + that.$t('route.AccountsPayable'), // 应付账户,
            key: 'username',
            width: 40
          };
        }
        columns.unshift(row);
        console.log(columns, '动态cloumns');
        Sheet1.columns = columns;
        Sheet1.mergeCells('A2:H2');
        Sheet1.getCell('A2').value = `
        1、* 必填项 /* Este campo é obrigatório
        2、不可更改此模板 /Esse modelo não pode ser alterado '`;

        Sheet1.getRow(2).getCell(1).font = {
          color: { argb: 'ff0000' }
        };

        Sheet2.columns = [
          {
            header: 'PIX' + that.$t('receivablePayable.accountType'), // 账号类型
            key: 'dictCodeType',
            width: 40
          }
        ];
        const Sheet2_data = [];
        that.dictCodeTypeList.map(item => {
          Sheet2_data.push({
            dictCodeType: item.label,
            width: 20
          });
        });
        Sheet2.addRows(Sheet2_data);

        Sheet3.columns = [
          {
            header: that.$t('orderCenterCont.CertificateType'), // 证件类型',
            key: 'documentType',
            width: 40
          }
        ];
        const Sheet3_data = [
          { documentType: 'CPF' },
          { documentType: 'CNPJ' }
        ];
        Sheet3.addRows(Sheet3_data);

        Sheet4.columns = [
          {
            header: that.$t('basicData.BankNumber'), // 银行编号,
            key: 'bankCode',
            width: 40
          }
        ];
        const Sheet4_data = [];
        that.bankList.map(item => {
          Sheet4_data.push({
            bankCode: item.code + '-' + '（' + item.name + '）' + item.ispd,
            width: 20
          });
        });
        Sheet4.addRows(Sheet4_data);
        // 添加付款方式选项
        Sheet5.columns = [
          {
            header: that.$t('basicData.PaymentMethod'), // 付款方式
            key: 'paymentMethod',
            width: 40
          }
        ];
        const Sheet5_data = [
          { paymentMethod: 'pix' },
          { paymentMethod: that.$t('basicData.bankTransfer') }, // 银行转账
          { paymentMethod: 'pix' + '+' + that.$t('basicData.bankTransfer') } // PIX和银行转账
        ];
        Sheet5.addRows(Sheet5_data);
        new Array(2000).fill(0).forEach((_, idx) => {
          const row = idx + 2;
          // 付款方式下拉
          Sheet1.getCell(row, 2).dataValidation = {
            type: 'list',
            formulae: [`=Sheet5!$A$2:$A${Sheet5_data.length + 1}`]
          };
          // 账户类型下拉框
          Sheet1.getCell(row, 3).dataValidation = {
            type: 'list',
            formulae: [`=Sheet2!$A$2:$A${Sheet2_data.length + 1}`]
          };

          // 证件类型下拉框
          Sheet1.getCell(row, 6).dataValidation = {
            type: 'list',
            formulae: [`=Sheet3!$A$2:$A${Sheet3_data.length + 1}`]
          };

          // 银行编号下拉框
          Sheet1.getCell(row, 8).dataValidation = {
            type: 'list',
            formulae: [`=Sheet4!$A$2:$A${Sheet4_data.length + 1}`]
          };
        });

        const buffer = await wb.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: 'application/octet-stream'
        });
        let fileName = that.$t('basicData.BankAccountImportTemplate') + '.xlsx';
        switch (that.type) {
          case 1:
            fileName = 'AJD' + that.$t('basicData.BankAccountImportTemplate') + '.xlsx';
            break;
          case 2:
            fileName = 'DSP' + that.$t('basicData.BankAccountImportTemplate') + '.xlsx';
            break;
          default:
            fileName = that.$t('collectionCenter.hut') + that.$t('basicData.BankAccountImportTemplate') + '.xlsx';
        }
        return saveAs(blob, fileName);
      }

      try {
        ddd();
      } catch (error) {
        console.error(error);
      }
    },
    onImportFile(data) {
      const importList = data[0].results.splice(1); // 解析数据
      const headObj = {
        [`*${this.$t('basicData.supplierNumber')}`]: 'code', // 供应商编号
        [`*${this.$t('route.AccountsPayable')}`]: 'username', // 应付账户
        [`*${this.$t('basicData.PaymentMethod')}`]: 'paymentMethod', // 付款方式
        [`*PIX${this.$t('receivablePayable.accountType')}`]: 'dictCodeType', // 账户类型
        [`*PIX${this.$t('customerManagements.account')}`]: 'dictCode', // 账户
        [`*${this.$t('basicData.ReceivingName')}`]: 'payeeName', // 收款名称
        [`*${this.$t('orderCenterCont.CertificateType')}`]: 'documentType', // 证件类型
        [`*${this.$t('basicData.CertificateNumber')}`]: 'documentNumber', // 证件号码
        [`*${this.$t('basicData.BankNumber')}`]: 'bankCode', // 银行编号
        [`*${this.$t('basicData.BranchNumber')}`]: 'branch', // 分行号码
        [`*${this.$t('basicData.ReceivingAccountNumber')}`]: 'bankNumber' // 收款账户
      };
      // const headObj = ['username', 'paymentMethod', 'dictCodeType', 'dictCode', 'payeeName', 'documentType', 'documentNumber', 'bankCode', 'branch', 'bankNumber'];
      const dataList = importList.map(item => {
        const data = {};
        Object.keys(item).forEach((key, i) => {
          console.log(item);
          console.log(key, i, item[key], headObj[i]);
          try {
            // 付款方式
            if (key === `*${this.$t('basicData.PaymentMethod')}`) {
              data[headObj[key]] = item[key] === 'pix' ? 1 : item[key] === this.$t('basicData.bankTransfer') ? 2 : item[key] === `pix+${this.$t('basicData.bankTransfer')}` ? 3 : null;
            } else if (key === `*${this.$t('basicData.BankNumber')}`) {
              // 银行编号
              data[headObj[key]] = item[key]?.split('-')?.shift() || '';
            } else if (headObj[key] && item[key]) {
              data[headObj[key]] = item[key];
            } else {
              data[headObj[key]] = '';
            }
          } catch (error) {
            this.$message.error(this.$t('receivablePayable.ImportTemplateIncorrect'));
            throw new Error(error);
          }
        });
        return data;
      });
      console.log(dataList);
      const fn = this.type === 3 ? apiCabinCollectionPayableAccountImport : apiDeliveryPayableAccountImport;
      fn({
        accountType: this.type,
        dataList
      }).then(res => {
        if (res.code === 200) {
          // this.$message.success(this.$t('basicData.TheOperationSucceeded'));
          goFileUploadManagement(this);

          this.bus.$emit('onClose', true);
        }
      }).catch(err => {
        console.log(err);
      });
    }
  }
};
</script>

<style scoped>

</style>
